import { DressingWeight } from '@sg/graphql-schema';

import { DRESSINGS } from '../../customization.machine.constants';

// ─────────────────────────────────────────────────────────────────────────────

export function getNextDressingWeight(dressingWeight: DressingWeight) {
  const dressingWeightIndex = DRESSINGS.WEIGHTS.indexOf(dressingWeight);
  const nextDressingWeightIndex = dressingWeightIndex + 1;
  const nextDressingWeight = DRESSINGS.WEIGHTS[nextDressingWeightIndex];

  return nextDressingWeight ?? DressingWeight.Heavy;
}

export function getPreviousDressingWeight(dressingWeight: DressingWeight) {
  const dressingWeightIndex = DRESSINGS.WEIGHTS.indexOf(dressingWeight);
  const prevDressingWeightIndex = dressingWeightIndex - 1;

  const prevDressingWeight = DRESSINGS.WEIGHTS[prevDressingWeightIndex];
  return prevDressingWeight ?? DressingWeight.Light;
}
